<script>
import _filter from 'lodash/filter'
import _forEach from 'lodash/forEach'
import _debounce from 'lodash/debounce'
import * as R from 'ramda'
import Loading from '@components/custom-loading'

export default {
  components: { Loading },
  props: {
    options: { type: Array, default: () => [] },
    fetchingData: { type: Boolean, default: false },
    selectedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      selectAll: false,
      keyword: '',
    }
  },
  computed: {
    selected() {
      return _filter(this.options, v => v.checked)
    },
    selectAllLabel() {
      return 'Select All (' + this.selectedCount + ')'
    },
    showLoadMore() {
      return this.options.length % 100 === 0
    },
  },
  watch: {
    keyword: function(newVal, oldVal) {
      this.debounce(newVal)
    },
    selected: {
      handler: function(newVal, oldVal) {
        this.$emit('updateSelected', this.options)
        this.selectAll = R.all(R.propEq('checked', true))(this.options)
      },
      deep: true,
    },
  },
  created() {
    this.debounce = _debounce(this.updateKeyword, 500)
    if (this.options.length > 0) {
      this.selectAll = R.all(R.propEq('checked', true))(this.options)
    }
  },
  mounted() {
    let sLabel = document.querySelector('.selectAll label')
    sLabel.addEventListener('click', this.clickLabelSelectAll)
  },
  methods: {
    updateKeyword(newVal) {
      this.$emit('updateKeyword', newVal)
    },
    selectNone() {
      _forEach(this.options, val => {
        val.checked = false
      })
      this.selectAll = false
      this.$emit('selectNone')
    },
    clickLabelSelectAll() {
      if (this.selectAll) {
        _forEach(this.options, val => {
          val.checked = true
        })
      } else {
        _forEach(this.options, val => {
          val.checked = false
        })
      }
    },
    clickSelectAll() {
      this.selectAll = !this.selectAll
      this.clickLabelSelectAll()
    },
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>

<template>
  <div class="reports-multi-select">
    <div class="search-bar">
      <v-icon class="search-icon">search</v-icon>
      <input
        v-model="keyword"
        type="text"
        class="input-style"
        aria-label="search input">
    </div>
    <div class="search-toolbar ml-3 mr-3 mt-2 mb-2">
      <v-checkbox
        v-model="selectAll"
        :label="selectAllLabel"
        class="selectAll"
        @click="clickSelectAll"/>
      <a @click="selectNone">Select None</a>
      <v-divider class="mt-2 mb-2"/>
    </div>
    <div
      id="select-options"
      class="select-options ml-3 mr-3">
      <Loading v-if="fetchingData"/>
      <div v-else>
        <v-checkbox
          v-for="(option,i) in options"
          :key="i"
          :label="option.name"
          v-model="option.checked"
        />
        <a
          v-if="showLoadMore"
          class="load-more"
          @click="loadMore">Load More</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.reports-multi-select {
  border: 1px solid #e6e6e6;
  width: 100%;
  height: 335px;
}
.search-toolbar {
  position: relative;
}
.search-toolbar a {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  position: absolute;
  line-height: 24px;
  right: 0px;
}
.search-toolbar a:hover {
  color: blue;
}
.search-toolbar .checkbox {
  display: inline-block;
  width: 150px;
}
.search-bar {
  height: 40px;
  border-bottom: 1px solid #e6e6e6;
}
.search-icon {
  margin-left: 10px;
  width: 10%;
}
.input-style {
  height: 100%;
  width: 80%;
  font-size: 14px;
}
.select-options {
  height: 238px;
  overflow-y: scroll;
}
.reports-multi-select >>> .input-group__details {
  display: none;
}
.reports-multi-select >>> .input-group label {
  line-height: 24px;
  height: 24px;
  font-size: 14px;
  font-size: 1rem;
  width: fit-content;
  width: auto;
}
.reports-multi-select >>> .input-group__input {
  min-height: 24px;
  height: 24px;
}
.reports-multi-select >>> .input-group--selection-controls__ripple {
  height: 24px;
}
.load-more {
  margin-top: 10px;
  display: inline-block;
}
.load-more:hover {
  font-weight: bold;
}
</style>
